// Exported from EmitterTool
export default {
  "name": "fire_cone",
  "effectKey": "basic",
  "pxPerMeter": 42,
  "showGrid": true,
  "EmitterPanel": {
    "shape": "cone",
    "showShape": true,
    "settings": {
      "radius": 1,
      "width": 2,
      "height": 2,
      "rotationDeg": 0,
      "angleDeg": 0,
      "spreadDeg": 60,
      "minDist": 0,
      "maxDist": 3,
      "pulseEnabled": false,
      "spawnFromOrigin": false,
      "spawnMode": "shape",
      "feederCount": 3,
      "feederRadiusM": 0.3,
      "feederJitterPct": 25,
      "beamEnabled": true,
      "beamBaseWidthPx": 24,
      "beamMaxLengthPx": 600,
      "beamCoreColor": "#ffffff",
      "beamGlowColor": "#66ccff",
      "beamCoreAlpha": 1,
      "beamGlowAlpha": 0.5,
      "beamHardCap": false,
      "beamCollideWithWalls": true,
      "beamPulseSpeed": 0.8,
      "beamNoise": 0.2,
      "beamNoiseSpeed": 1,
      "beamTileW": 128,
      "beamAngleDeg": 0,
      "startDeg": 0,
      "endDeg": 90,
      "arcSweepDeg": 90,
      "arcRotationDeg": 0,
      "rotationAnimEnabled": false,
      "rotationAnimDir": "ccw",
      "rotationAnimSpeedDegS": 45,
      "rotationAffectsParticles": true,
      "overlayCling": false
    },
    "rule": {
      "fireMode": "rule",
      "ruleStyle": "timed",
      "ruleDurationS": 3
    }
  },
  "TargetingPanel": {
    "presetId": "direction",
    "rangeM": 1.5,
    "headSpeedMps": 40
  },
  "SpritePanel": {
    "mode": "single",
    "selectedSprite": "mc_fx-explo_0007",
    "selectedSprites": [
      "mc_fx-explo_0007"
    ],
    "selectedAnimFrames": [],
    "animFps": 12
  },
  "ParticlesPanel": {
    "pps": 35,
    "maxAlive": 105,
    "speedMin": 1,
    "speedMax": 3,
    "lifespanMode": "range",
    "lifeMinS": 1,
    "lifeMaxS": 2.5,
    "rangeMeters": 3,
    "targetKillDistMeters": 0.25,
    "alphaStart": 1,
    "alphaEnd": 0,
    "scaleStart": 0,
    "scaleEnd": 1,
    "blendMode": "ADD",
    "tintEnabled": false,
    "tintStart": "#ffffff",
    "tintEnd": "#ffffff",
    "tintEase": "linear",
    "facingMode": "deg_from_origin",
    "facingDegFromOrigin": 0
  },
  "OrbitPanel": {
    "orbitEnabled": false,
    "orbitDirection": "ccw",
    "orbitSpeedAbsDps": 90,
    "orbitSpeedDegPerS": 90,
    "orbitLockRadii": true,
    "orbitRadiusMinM": 1,
    "orbitRadiusMaxM": 1,
    "orbitShape": "circle",
    "orbitEllipseRxM": 1,
    "orbitEllipseRyM": 1,
    "orbitEllipseTiltDeg": 0,
    "orbitStartPhaseMode": "random",
    "orbitStartPhaseJitterDeg": 30,
    "orbitApplyMode": "all",
    "orbitApplyPercent": 100
  },
  "RotationPanel": {
    "rotateEnabled": false,
    "rotateDirection": "ccw",
    "rotateSpeedAbsDps": 90,
    "rotateSpeedDegPerS": 90
  },
  "GravityPanel": {
    "gravityEnabled": false,
    "gravitySpeed": 0,
    "gravityLingerS": 0
  },
  "CollisionPanel": {
    "useWalls": true,
    "wallResponse": "travel",
    "useTokenCollision": true,
    "tokenResponse": "flowAround",
    "collisionEffectEnabled": false,
    "collisionSprite": "",
    "collisionScale": 1,
    "collisionAlpha": 1,
    "collisionLifespanMs": 400,
    "collisionFxRotationMode": "none"
  },
  "GlowPanel": {
    "glowEnabled": true,
    "glowPercent": 15,
    "glowIntensity": 0.65,
    "glowReachM": 2.7,
    "glowReachPx": 0,
    "glowDurationS": 0.9,
    "tintEnabled": false,
    "tintStart": "#ffffff",
    "tintEnd": "#ffffff"
  },
  "parent": {
    "emitterShape": "cone",
    "shapeSettings": {
      "radius": 1,
      "width": 2,
      "height": 2,
      "rotationDeg": 0,
      "angleDeg": 0,
      "spreadDeg": 60,
      "minDist": 0,
      "maxDist": 3,
      "pulseEnabled": false,
      "spawnFromOrigin": false,
      "spawnMode": "shape",
      "feederCount": 3,
      "feederRadiusM": 0.3,
      "feederJitterPct": 25,
      "beamEnabled": true,
      "beamBaseWidthPx": 24,
      "beamMaxLengthPx": 600,
      "beamCoreColor": "#ffffff",
      "beamGlowColor": "#66ccff",
      "beamCoreAlpha": 1,
      "beamGlowAlpha": 0.5,
      "beamHardCap": false,
      "beamCollideWithWalls": true,
      "beamPulseSpeed": 0.8,
      "beamNoise": 0.2,
      "beamNoiseSpeed": 1,
      "beamTileW": 128,
      "beamAngleDeg": 0,
      "startDeg": 0,
      "endDeg": 90,
      "arcSweepDeg": 90,
      "arcRotationDeg": 0,
      "rotationAnimEnabled": false,
      "rotationAnimDir": "ccw",
      "rotationAnimSpeedDegS": 45,
      "rotationAffectsParticles": true,
      "overlayCling": false
    },
    "effectSettings": {
      "fogHidden": false,
      "fogAlpha": 1,
      "orbitMode": "aroundOrigin",
      "rotateEnabled": false,
      "rotateDirection": "ccw",
      "rotateSpeedAbsDps": 90,
      "rotateSpeedDegPerS": 90,
      "gravityEnabled": false,
      "spriteMode": "single",
      "selectedSprite": "mc_fx-explo_0007",
      "selectedSprites": [
        "mc_fx-explo_0007"
      ],
      "selectedAnimFrames": [],
      "spriteAnimatedEnabled": false,
      "pps": 35,
      "maxAlive": 105,
      "speedMin": 1,
      "speedMax": 3,
      "lifespanMode": "range",
      "lifeMinS": 1,
      "lifeMaxS": 2.5,
      "rangeMeters": 3,
      "targetKillDistMeters": 0.25,
      "alphaStart": 1,
      "alphaEnd": 0,
      "scaleStart": 0,
      "scaleEnd": 1,
      "blendMode": "ADD",
      "tintEnabled": false,
      "tintStart": "#ffffff",
      "tintEnd": "#ffffff",
      "tintEase": "linear",
      "facingMode": "deg_from_origin",
      "facingDegFromOrigin": 0,
      "orbitEnabled": false,
      "orbitDirection": "ccw",
      "orbitSpeedAbsDps": 90,
      "orbitSpeedDegPerS": 90,
      "orbitLockRadii": true,
      "orbitRadiusMinM": 1,
      "orbitRadiusMaxM": 1,
      "orbitShape": "circle",
      "orbitEllipseRxM": 1,
      "orbitEllipseRyM": 1,
      "orbitEllipseTiltDeg": 0,
      "orbitStartPhaseMode": "random",
      "orbitStartPhaseJitterDeg": 30,
      "orbitApplyMode": "all",
      "orbitApplyPercent": 100,
      "orbitGroupTransform": false,
      "gravitySpeed": 0,
      "gravityLingerS": 0,
      "glowEnabled": true,
      "glowPercent": 15,
      "glowIntensity": 0.65,
      "glowReachM": 2.7,
      "glowReachPx": 0,
      "glowDurationS": 0.9,
      "useWalls": true,
      "wallResponse": "travel",
      "useTokenCollision": true,
      "tokenResponse": "flowAround",
      "collisionEffectEnabled": false,
      "collisionScale": 1,
      "collisionAlpha": 1,
      "collisionLifespanMs": 400,
      "collisionFxRotationMode": "none",
      "subEmitters": [],
      "subEmittersEnabled": false,
      "subEmittersParentIndex": 0,
      "trailEnabled": false
    },
    "selectedSprite": "mc_fx-explo_0007",
    "showShape": true
  },
  "layers": []
};
